module.exports = __webpack_public_path__ + "static/img/nps-pt.6b98be3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/nps-pt.jpg
// module id = gYjp
// module chunks = 0